import useTranslation from '@/hooks/i18n';

import { MeditationEntity, MeditationPage, ResponseCollectionMeta } from '@/graphql/generated/graphql';
import { create } from 'zustand';
import { fetchMeditationPage, fetchMeditationPageable } from '@/services/meditation/meditation.service';

type MeditationStore = {
  loading: boolean;
  page: { page: MeditationPage | null };
  meditations: MeditationEntity[];
  latestMeditation: MeditationEntity[];
  meditationsMeta: ResponseCollectionMeta | null;
  onChangePage: (page: number) => Promise<void>;
  onInit: () => Promise<void>;
  t: (value: string) => string;
};

export const useMeditationStore = create<MeditationStore>()((set) => ({
  loading: true,
  page: { page: null },
  meditations: [],
  latestMeditation: [],
  meditationsMeta: null,
  highlight: {},
  t: useTranslation().t,
  onInit: async () => {
    set({ loading: true });
    const page = await fetchMeditationPage();

    const { meditations, meta } = await fetchMeditationPageable(1);

    set({
      page,
      latestMeditation: meditations?.slice(0, 2) as MeditationEntity[],
      meditations: meditations as MeditationEntity[],
      meditationsMeta: meta as ResponseCollectionMeta,
      loading: false,
    });
  },
  onChangePage: async (page: number) => {
    const { meditations, meta } = await fetchMeditationPageable(page);

    set({
      meditations: meditations as MeditationEntity[],
      meditationsMeta: meta as ResponseCollectionMeta,
    });
  },
}));
